import app from 'flarum/forum/app';
import Icon from 'flarum/common/components/Icon';
import extractText from 'flarum/common/utils/extractText';
/**
 * The avatar for "you have no handle here yet" -- Task 4.1, shared with the
 * reply placeholder at 4.2.
 *
 * Not a monogram: there is no handle to draw one from, and inventing a
 * candidate would be a preview of a name that does not exist -- the thing
 * Task 4.0 deferred. Not Flarum's empty fallback circle either, which is what
 * 5.6 removed from the discussion list for looking broken.
 *
 * Its own file rather than beside `HandleAvatar`, so the monogram's jest tests
 * keep importing nothing but pure functions.
 */
export default function PendingHandleAvatar(className) {
  const label = extractText(app.translator.trans('ideasynq-handles.forum.composer.pending_avatar_label'));
  return m("span", {
    className: `Avatar IdeaSynqAvatar IdeaSynqAvatar--pending ${className}`,
    role: "img",
    "aria-label": label,
    title: label
  }, m(Icon, {
    name: "fas fa-user-secret"
  }));
}